(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kaya-product-card"] && !Shopify.designMode) return;
  try {
    /* Kaya product card — variant select + quantity picker interactivity */
  (function () {
    'use strict';

    function initCard(card) {
      if (card.dataset.kayaReady) return;
      card.dataset.kayaReady = '1';

      var select       = card.querySelector('.kaya-card__variant-select');
      var variantInput = card.querySelector('.kaya-card__variant-id');
      var priceEl      = card.querySelector('[data-kaya-price]');
      var qtyMinus     = card.querySelector('.kaya-card__qty-btn--minus');
      var qtyPlus      = card.querySelector('.kaya-card__qty-btn--plus');
      var qtyInput     = card.querySelector('.kaya-card__qty-input');

      /* Variant select -------------------------------------------- */
      if (select && variantInput) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];

          /* Update the hidden variant ID the form submits */
          variantInput.value = opt.value;

          /* Update displayed price */
          if (priceEl && opt.dataset.price) {
            priceEl.textContent = opt.dataset.price;
          }

          /* Enable/disable the ATC button */
          var atcBtn = card.querySelector('[ref="addToCartButton"]');
          if (atcBtn) {
            atcBtn.disabled = opt.dataset.available !== 'true';
          }
        });
      }

      /* Quantity picker ------------------------------------------- */
      if (qtyMinus && qtyPlus && qtyInput) {
        qtyMinus.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          if (v > 1) qtyInput.value = v - 1;
        });

        qtyPlus.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = v + 1;
        });

        /* Clamp on manual edit */
        qtyInput.addEventListener('change', function () {
          var v = parseInt(qtyInput.value, 10);
          if (!v || v < 1) qtyInput.value = 1;
        });
      }
    }

    /* Initialise cards already in the DOM */
    function initAll() {
      document.querySelectorAll('.kaya-card').forEach(initCard);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    /* Pick up cards added via infinite scroll */
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.classList.contains('kaya-card')) {
            initCard(node);
          } else {
            node.querySelectorAll('.kaya-card').forEach(initCard);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }());
  } catch(e) { console.error(e); }
})();

})();
